import { AfterViewChecked, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { lastValueFrom, Subscription } from 'rxjs';

//interfaces
import { OrderItemInterface } from '../shared/interfaces';

//services
import { OrderService } from '../shared/services';

//helpers
import { OrderHelper } from '../shared/helpers';

//icons
import { OrderPreviewItemInterface } from '../shared/interfaces/order-preview.interface';
import { ProductIdentifierEnum, ProductTypeEnum } from '../shared/enums';


@Component({
  selector: 'app-basket',
  templateUrl: './basket.component.html',
  styleUrl: './basket.component.scss'
})
export class BasketComponent implements OnInit, AfterViewChecked, OnDestroy {
  @ViewChild('productsContainer') private productsContainer: ElementRef;
  @ViewChild('modal', { static: false }) modal: ElementRef;


  public readonly categories = [
    {
      id: 1,
      name: "Brot",
      icon: 'fa-bread-slice'
    },
    {
      id: 2,
      name: "Früchte & Gemüse",
      icon: 'fa-apple-whole'
    },
    {
      id: 3,
      name: "Süssgebäck & Snacks",
      icon: 'fa-cookie-bite'
    },
    {
      id: 4,
      name: "Diverses",
      icon: 'fa-bag-shopping'
    }
  ]

  public orderItems: OrderPreviewItemInterface[] = [];
  public discount: string | null = null;
  public selectedIndex: number | null = null;

  public loading: boolean = false;


  //manual search
  public enterBarcode: boolean = false;
  public errorScanned: boolean = false;
  public entredProduct: OrderPreviewItemInterface | null = null;
  public readonly keypad: string[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '#', '0', 'X']
  public scannedCode: string = '';

  public productTypeEnum = ProductTypeEnum;

  private $debounce: any | null = null;

  constructor(
    private orderHelper: OrderHelper,
    private orderService: OrderService
  ) { }

  private $order: Subscription;
  private $loading: Subscription;

  async ngOnInit() {
    /* try {
      OrderService.order.next(JSON.parse('{"shopId":8,"itemList":[{"article":{"id":58243,"quantity":2}},{"article":{"barcode":"2100005010000","quantity":1}}]}'));
      const data = await lastValueFrom(this.orderService.calculateOrder());
      OrderService.orderPreview.next({ new: null, order: data });
      OrderService.loading.next(false);
    } catch (error) {

    } */
    this.$loading = OrderService.loading.subscribe((val) => {
      this.loading = val;
    })
    this.$order = OrderService.orderPreview.subscribe((val) => {
      this.orderItems = val.order?.itemList || [];
      this.selectedIndex = val.new;
      if (val.order?.discounts?.length) {
        this.discount = val.order!.discounts[0].discount.description?.substring(0, 12) + '%'
      }
      this.scrollToBottom();
    })
  }

  ngAfterViewChecked(): void {
    this.scrollToBottom()
  }

  public correction(index: number, quantity: number) {
    OrderService.loading.next(true);
    console.log(OrderService.loading.value)
    this.orderHelper.correctBasket(index, quantity);
    this.orderHelper.recalculateOrder(quantity ? index : null);
  }


  private scrollToBottom(): void {
    try {
      this.productsContainer.nativeElement.scrollTop = this.productsContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }


  public fallback() {
    if (this.orderItems.length) {
      OrderService.fallback.next(true);
    } else {
      this.orderService.restart();
    }
  }

  //manual search
  public stopBarcode() {
    this.modal.nativeElement.classList.add('close')
    setTimeout(() => {
      this.enterBarcode = false;
      this.entredProduct = null;
      this.errorScanned = false;
      this.scannedCode = '';
      this.modal.nativeElement.classList.remove('close')
    }, 300);
  }
  public pressedKey(key: string) {
    this.errorScanned = false;
    if (key == 'X') {
      this.scannedCode = this.scannedCode.substring(0, this.scannedCode.length - 1);
    } else {
      this.scannedCode += key;
    }

  }

  public searchProduct() {
    this.entredProduct = null;
    this.errorScanned = false;
    this.orderService.getArticleByBarcode(this.scannedCode).subscribe({
      next: data => {
        const product = data.itemList[0];
        console.log(data.itemList[0])
        this.entredProduct = product
      },
      error: err => {
        console.log(err)
        this.errorScanned = true;
      }
    })
  }

  public toBasket() {
    this.modal.nativeElement.classList.add('close')
    this.orderHelper.addToBasket(this.scannedCode, ProductIdentifierEnum.barcode, this.entredProduct!.productType, this.entredProduct!.quantity);
    this.orderHelper.recalculateOrder();
    setTimeout(() => {
      this.enterBarcode = false;
      this.entredProduct = null;
      this.errorScanned = false;
      this.scannedCode = '';
      this.modal.nativeElement.classList.remove('close')
    }, 300);
  }

  ngOnDestroy(): void {
    this.$order.unsubscribe();
    this.$loading.unsubscribe();
    if (this.$debounce) clearInterval(this.$debounce);
  }
}
